import { ModalIsland, Button } from "@saviynt/design-system";
import { Dispatch, SetStateAction } from "react";
import { FormattedMessage, useIntl } from "react-intl";

export type PolicyActionVariant = "delete" | "disable" | "enable" | "discard";

interface PolicyActionModalProps {
  variant: PolicyActionVariant;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  onConfirm: () => void;
}

const config = {
  delete: {
    title: {
      defaultMessage: "Do you want to delete?",
      id: "70Papl",
      description: "Title for delete policy confirmation modal",
    },
    subtitle: {
      defaultMessage:
        "Removing this policy will permanently stop related identity insights and governance. This action cannot be undone.",
      id: "cIX3qR",
      description: "Subtitle for delete policy confirmation modal",
    },
    confirm: {
      defaultMessage: "Yes, Delete",
      id: "iqUEVm",
      description: "Text for delete button",
    },
  },
  disable: {
    title: {
      defaultMessage: "Do you want to Disable?",
      id: "faiWe5",
      description: "Title for disable policy confirmation modal",
    },
    subtitle: {
      defaultMessage:
        "When you disable a policy, all related risk findings will be closed.",
      id: "gbpJDx",
      description: "Subtitle for disable policy confirmation modal",
    },
    confirm: {
      defaultMessage: "Yes, Disable",
      id: "mlBXT/",
      description: "Text for disable button",
    },
  },
  enable: {
    title: {
      defaultMessage: "Do you want to Enable?",
      id: "faiWe5",
      description: "Title for enable policy confirmation modal",
    },
    subtitle: {
      defaultMessage:
        "Enabling this policy will initiate a risk evaluation, which may generate new findings. Do you want to continue?",
      id: "gbpJDx",
      description: "Subtitle for enable policy confirmation modal",
    },
    confirm: {
      defaultMessage: "Yes, Enable",
      id: "mlBXT/",
      description: "Text for enable button",
    },
  },
  discard: {
    title: {
      defaultMessage: "Do you want to Discard changes?",
      id: "faiWe5",
    },
    subtitle: {
      defaultMessage:
        "You've made changes that haven't been saved yet.If you continue, all changes will be permanently lost.",
      id: "gbpJDx",
      description: "Subtitle for enable policy confirmation modal",
    },
    confirm: {
      defaultMessage: "Yes, Discard",
      id: "mlBXT/",
      description: "Text for Discard button",
    },
  },
} as const;

export default function PolicyActionModal({
  variant,
  isOpen,
  setIsOpen,
  onConfirm,
}: PolicyActionModalProps) {
  const intl = useIntl();
  const { title, subtitle, confirm } = config[variant];

  return (
    <ModalIsland
      kind="warning"
      alertTitle={intl.formatMessage(title)}
      alertSubtitle={intl.formatMessage(subtitle)}
      onClose={() => setIsOpen(false)}
      isOpen={isOpen}
      primaryButton={
        <Button type="button" kind="outlined" size="medium" onClick={onConfirm}>
          <FormattedMessage {...confirm} />
        </Button>
      }
      secondaryButton={
        <Button
          type="button"
          kind="ghost"
          size="medium"
          onClick={() => setIsOpen(false)}
        >
          <FormattedMessage
            defaultMessage="Cancel"
            id="ti5TEd"
            description="Text for cancel button"
          />
        </Button>
      }
    />
  );
}
